<template>
  <secondary-nav />
  <div class="home">
    <h2>Nyheter</h2>
    <News
      publiced="2026-07-13"
      title="Resultat publicerade"
      newsText="Resultat för årets tävling finns nu publicerade. Stort tack till alla tävlande och alla funktionärer för era insatser!"
      newsImg="wheels.jpg"
      externalLink="https://my.raceresult.com/408258/"
      linkText="Till resultaten (öppnas i nytt fönster)"
    >
    </News>
    <News
      publiced="2026-07-09"
      title="Kartor Tri4Fun"
      newsText="Kartor för Tri4Fun finns nu publicerade. Klicka på länkarna nedan för att öppna dom i nya flikar."
      newsImg="swimmers-2.jpg"
      imgLeft
    >
      <p>
        <a href="/maps/vxlsimTri4Fun.jpg" target="_blank"
          >Växling & Simning (öppnas i nytt fönster)</a
        >
      </p>
      <p>
        <a href="/maps/CykelTri4Fun.jpg" target="_blank"
          >Cykel (öppnas i nytt fönster)</a
        >
      </p>
      <p>
        <a href="/maps/LopTri4Fun.jpg" target="_blank"
          >Löpning (öppnas i nytt fönster)</a
        >
      </p>
    </News>
    <News
      publiced="2026-06-27"
      title="Starttider publicerade"
      newsText="Starttider för 2026 års Säter Triathlon finns nu publicerade. Ni hittar dom under fliken Deltagare eller klicka på bilden till höger för att se dom direkt."
      newsImg="starttider.jpg"
      imgLink="/starttider.jpg"
    >
    </News>
    <News
      imgLeft
      publiced="2026-06-27"
      title="PM publicerad"
      newsText="PM för 2026 års Säter Triathlon finns nu publicerad. Ni hittar den under fliken Deltagare."
      newsImg="swimmers.jpg"
    ></News>
    <News
      publiced="2026-04-25"
      title="Information om 2026 års tävling"
      newsText="Eftersom kommunen kommer att göra ett omfattande vägarbete på cykelsträckan under sommaren där vi genomfört tävlingen tidigare år, som medför att vi inte kan genomföra cykelsträckorna i sommar, så måste vi flytta tävlingen till andra sidan av sjön till Skönviks området. Grova kartor finns på hemsidan men mer detaljerade kartor och detaljerad information kommer inom kort.
      <br><br>Detta har även medfört att vi inte kan genomföra supersprint på avstängda vägar och kommer innebära att Junior och 16-17 år klasser blir vanlig sprint tävling 750m – 20km – 5km och 14-15 blir supersprint 375m – 10km – 2,5km på trafikerade vägar så Drafting kommer inte att bli tillåten.
"
      newsImg="bikes.jpg"
    >
    </News>
    <!-- <News
      imgLeft
      publiced="2026-01-13"
      title="Anmälan öppen"
      newsText="Anmälan till 2026 års Säter Triathlon är nu öppen. Inbjudan finner ni under fliken Deltagare."
      newsImg="wheels.jpg"
      externalLink="https://mittlopp.se/anm/satertriathlon2026"
      linkText="Till anmälan (öppnas i nytt fönster)"
    ></News> -->
    <!-- <News
      publiced="2026-01-13"
      title="Hemsida under ombyggnad"
      newsText="Hemsidan är under ombyggnad, begränsad information finns tillgänglig under tiden. Mer information kommer inom kort."
      newsImg="rebuild.jpg"
    >
    </News> -->
    <!-- <News
      imgLeft
      publiced="2025-07-03"
      title="Startlista"
      newsText="Startlistan finns nu publicerad."
      newsImg="wheels.jpg"
      externalLink="https://my.raceresult.com/346881/"
      linkText="Till startlistan (öppnas i nytt fönster)"
    ></News> -->
    <!-- <News
      publiced="2025-06-24"
      title="Pre-race info"
      newsImg="bikes.jpg"
      newsText="Pre-race info för Supersprint, SM och RM finnt nu ute. Hittas
    under fliken deltagare, eller direkt via länkarna nedan."
      externalLink="https://youtu.be/0Ohe0Etn3HA"
      linkText="Pre-race info SM och RM"
      externalSecondLink="https://youtu.be/0sYTOZfhlDE"
      secondLinkText="Pre-race info Supersprint"
    /> -->
    <!-- <News
    publiced="2023-07-10"
    title="Resultat 2023"
    newsImg="wheels.jpg"
    imgLeft
    newsText="Preliminära resultat för årets tävling finns nu publicerade. Stort tack till alla tävlande och alla funktionärer för era insatser!">
    <router-link to="/results">Resultat</router-link>
    </News> -->

    <!--
    <News
    publiced="2023-06-25"
    title="PM 2023"
    newsImg="Satertriathlon_logo_vit.jpg"
    newsText="PM för årets tävling finns nu publicerad. Ni hittar det genom att klicka på fliken 'Deltagare' i menyn"
    />
    <News
    publiced="2023-04-25"
    title="Kartor"
    newsImg="Satertriathlon_logo_vit.jpg"
    newsText="Nu finns kartor och preliminära starttider ute. Ni hittar dom under fliken 'deltagare'"
    imgLeft
    />
    <News
    publiced="2023-03-20"
    newsImg="Satertriathlon_logo_vit.jpg"
    newsText="Upplägget för supersprinten kommer att göras om enligt önskemål från aktiva efter förra årets tävling, exakta upplägget inte klargjort än, information kommer så snart allt är klart. Starttiderna kan komma att justeras när formatet är klarlagt"
    />
    <News
    publiced="2023-01-22"
    newsImg="bike.jpg"
    newsText='Inbjudan till 2023 års tävling finns nu publicerad. Ni hittar den under fliken "deltagare" i menyn  '
    imgLeft /> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import News from "@/components/news.vue";
import SecondaryNav from "@/components/secondaryNav.vue";

export default {
  name: "Home",
  components: {
    // HelloWorld,
    News,
    SecondaryNav,
  },
};
</script>
